import React from "react";

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[CaribNavi] render error", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white p-6">
          <div className="max-w-md text-center space-y-4">
            <h1 className="text-2xl font-serif font-bold">CaribNavi is reloading</h1>
            <p className="text-white/70 text-sm">
              Something blocked the homepage render. Refresh the page — if this persists, contact support.
            </p>
            <button
              type="button"
              className="px-5 py-2.5 rounded-full bg-cyan-500 hover:bg-cyan-600 font-medium"
              onClick={() => window.location.reload()}
            >
              Refresh
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
